import {
  AssignmentQuestionCategory,
  IObtainedMarksForQuestion,
  QuestionAttemptStatus,
  QuestionAttemptStatusType,
} from '../../../types/assignmentTypes';

export const getQuestionAttemptStatus = (
  question: IObtainedMarksForQuestion,
  flow: 'submit' | 'preview' | 'review',
): QuestionAttemptStatusType => {
  const {
    type,
    obtainedMarks,
    marks,
    correctOptions,
    selectedOptions,
    subjectiveAnswer,
    attachments,
  } = question;

  if (flow === 'review') {
    if (obtainedMarks === marks) return QuestionAttemptStatus.CORRECT;

    if (type === AssignmentQuestionCategory.SUBJECTIVE) {
      return subjectiveAnswer?.trim()
        ? QuestionAttemptStatus.ATTEMPTED
        : QuestionAttemptStatus.SKIPPED;
    }

    if (
      type === AssignmentQuestionCategory.SINGLE_SELECT ||
      type === AssignmentQuestionCategory.MULTIPLE_SELECT
    ) {
      const isCorrect =
        selectedOptions?.length &&
        selectedOptions.every((option) => correctOptions?.includes(option));

      return isCorrect
        ? QuestionAttemptStatus.CORRECT
        : QuestionAttemptStatus.WRONG;
    }
  }

  if (
    selectedOptions?.length ||
    subjectiveAnswer?.trim() ||
    attachments?.length
  ) {
    return QuestionAttemptStatus.ATTEMPTED;
  }

  return QuestionAttemptStatus.SKIPPED;
};

export const extractPlainTextAndCountCharacters = (text: string) => {
  const plainText = text
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/\n/g, '');
  return {
    plainText,
    characterCount: plainText.length,
  };
};
